export class WelcomeLayer
{
	forceTimer: any;

	constructor (private $root : JQuery)
	{
	}

	setMessage(message)
	{
		if (message) {
			this.$root.addClass("sxc-visible");
			this.$root.find(".sxccw-msg").text(message);
		} else {
			this.$root.removeClass("sxc-visible");
		}
	}

	forceShow(t)
	{
		this.$root.addClass("sxc-forced");
		clearTimeout(this.forceTimer);
		this.forceTimer = setTimeout(() => {
			this.$root.removeClass("sxc-forced");
		}, t)
	}

	private fadeOutReason : string[] = [];

	fadeOut(reason : string)
	{
		if (this.fadeOutReason.indexOf(reason) > -1) {
			this.fadeOutReason.push(reason);
		}

		this.$root.addClass("sxc-hidden");
	}

	fadeIn(reason : string) {
		this.fadeOutReason = this.fadeOutReason.filter(x => x !== reason);
		if (!this.fadeOutReason.length) {
			this.$root.removeClass("sxc-hidden");
		}
	}

	setHidden(h)
	{
		this.$root[h ? "addClass" : "removeClass"]("sxc-hidden");
	}
}
